import { useNavigate } from "react-router-dom";
import Button, { EButtonColor } from "../Button/Button";
import { useConfirmModal } from "../Modal/useConfirmModal";


interface IProps {
  onSubmit: () => void;
  isLoading: boolean;
  onDelete?: () => void;
  deleteConfirmMessage?: string;
  isDeleting?: boolean;
}

const FormButtons: React.FC<IProps> = ({ onSubmit, isLoading, onDelete, isDeleting, deleteConfirmMessage }) => {
  const navigate = useNavigate();
  const openConfirmModal = useConfirmModal();

  const deleteHandler = async () => {
    const success = await openConfirmModal(deleteConfirmMessage);
    if (success && onDelete) {
      onDelete();
    }
  }
  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <Button onClick={onSubmit} loading={isLoading} color={EButtonColor.SUCCESS}>
        Save
      </Button>
      <Button onClick={() => navigate(-1)} color={EButtonColor.SECONDARY}>Back</Button>
      {onDelete && (
        <Button onClick={deleteHandler} loading={isDeleting} color={EButtonColor.DANGER}>Delete</Button>
      )}
    </div>
  )

}

export default FormButtons;